// Client-side public surface: what other modules may use.

import { lazyView } from "@/platform/client";

export const HealthLogPage = lazyView(() =>
  import("./ui/health/HealthPage.js").then((m) => m.HealthLogPage),
);
export const HealthOverviewPage = lazyView(() =>
  import("./ui/health/HealthPage.js").then((m) => m.HealthOverviewPage),
);
